<!-- TABS -VALUES -->
<div *ngIf="type === 'values'">
    <div *ngFor="let  item of data; let i=index">
        <app-title-section [title]="item.title" [type]="'title'">
        </app-title-section>
        <br>
        <div class="flex flex-wrap px-5" id="tabs-id">
            <div class="w-full overflow-hidden bg-white border border-gray-200 shadow-lg">
                <!-- links -->
                <ul
                    class="relative z-10 flex flex-row items-center justify-center py-4 mb-0 list-none bg-white border border-b-2 border-gray-200">
                    <li *ngFor="let itemFeatures of item.features; let j=index"
                        class="text-center border-r-2 border-gray-300 lg:border-r-4 sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl last:border-r-0">
                        <a class="px-1 py-3 font-semibold leading-normal normal-case cursor-pointer md:px-2 lg:px-5"
                            (click)="changeActiveTab(data[0].features, itemFeatures.id, $event)"
                            [ngClass]="itemFeatures.active ?'text-sigma-300 font-medium':'text-gray-500 font-normal'">
                            {{itemFeatures.title}}
                        </a>
                    </li>
                </ul>
                <div class="px-3 md:px-12 lg:px-24">
                    <!-- <div class="border-b-2 border-gray-200"></div> -->
                </div>
                <!-- contenido -->
                <div class="flex flex-col w-full break-words">
                    <div class="flex-auto px-4 py-5 ">
                        <div class="tab-content tab-space " *ngFor="let itemFeaturesPage of item.features; let j=index">

                            <div class="flex flex-col" id="{{itemFeaturesPage.id}}"
                                [ngClass]="itemFeaturesPage.active?'flex':'hidden'">

                                <div class="flex flex-col items-center justify-start">
                                    <div class="absolute md:w-4/5 xl:w-3/5 bg-sigma-200 rounded-b-xl panel-tab"
                                        [ngClass]="itemFeaturesPage.active ? 'panel-tab':'inactive'">
                                        <p
                                            class="text-xl font-semibold text-justify text-white md:p-6 xl:p-10 md:text-xl lg:text-2xl xl:text-3xl">
                                            {{itemFeaturesPage.description}}
                                        </p>
                                    </div>
                                </div>


                                <div class="w-full">
                                    <picture>
                                        <source type="image/webp" [attr.defaultImage]="itemFeaturesPage.img +'.webp'"
                                            [attr.lazyLoad]="itemFeaturesPage.img +'.webp'" />
                                        <img [defaultImage]="itemFeaturesPage.img +'.jpg'"
                                            [lazyLoad]="itemFeaturesPage.img +'.jpg'" />
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>